import { selectCurrentOrganizationHeadquartersLocation } from 'src/features/auth/selectors';

import { useAppSelector } from '../store/hooks';

export function MissingHeadquartersBanner() {
  const headquarters = useAppSelector(
    selectCurrentOrganizationHeadquartersLocation
  );

  if (headquarters) {
    return null;
  }

  return (
    <div
      data-testid="missing-headquarters-banner"
      className="bg-yellow-600 p-2 text-center text-base font-bold text-white"
    >
      <span>
        Warning: Your organization headquarters location has not been set. This
        will cause issues with displaying trips on the dispatch calendar, and
        map localization.
      </span>
      <a href="/settings" className="ml-2 underline">
        Set headquarters location
      </a>
    </div>
  );
}
